<template>
  <v-sheet
    rounded
    class="pa-3 mt-2"
    color="blue-grey lighten-5"
    style="border: 1px solid #cfd8dc"
  >
    <div class="d-flex align-center mb-2">
      <v-icon small color="primary" class="mr-2">mdi-gavel</v-icon>
      <div class="text-overline primary--text" style="line-height: 1">
        Päätös
      </div>
    </div>
    <div class="text-body-2 text-pre-line mb-2">
      {{ decision }}
    </div>
    <div
      class="d-flex justify-end caption grey--text text--darken-1 font-italic"
      v-if="decisionModifiedBy"
    >
      {{ decisionModifiedBy.user }}
      <span v-if="decisionModifiedAt" class="ml-1">
        &bull;
        {{ $formatDateAndHourMinute(decisionModifiedAt) }}
      </span>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: "TehtavaDecisionDisplay",
  props: {
    decision: {
      type: String,
      default: "",
    },
    decisionModifiedBy: {
      type: Object,
      default: null,
    },
    decisionModifiedAt: {
      type: [Number, String, Date],
      default: null,
    },
  },
};
</script>
